<div class="maintenance-banner" [class.compact]="compact" *ngIf="message">
  <div class="inner">
    <div class="icon-wrap" aria-hidden="true">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
    </div>
    <p class="text">
      <strong>{{ 'components.maintenanceBanner.prefix' | translate }}</strong> {{ message }}
    </p>
  </div>
</div>
